// material-ui
import { alpha } from '@mui/material/styles';

// ==============================|| OVERRIDES - DATA GRID ||============================== //

export default function DataGrid(theme) {
  return {
    MuiDataGrid: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          border: 0,
          borderRadius: 12,
          overflow: 'hidden',
          marginLeft: 0,
          marginRight: 0,
          marginBottom: 0,
          backgroundColor: theme.palette.common.white,
          color: theme.palette.text.primary,
          '& .MuiDataGrid-overlayWrapper': {
            minHeight: 220
          },
          '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
            outline: 'none'
          }
        },
        columnHeader: {
          backgroundColor: '#f8fafc',
          color: theme.palette.text.secondary,
          fontWeight: 700,
          borderBottom: `1px solid ${theme.palette.divider}`
        },
        columnHeaderTitle: {
          fontWeight: 700,
          fontSize: '0.78rem',
          textTransform: 'uppercase',
          letterSpacing: 0
        },
        columnSeparator: {
          color: theme.palette.divider
        },
        row: {
          borderTop: `1px solid ${theme.palette.divider}`,
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.035)
          },
          '&.Mui-selected': {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
            '&:hover': {
              backgroundColor: alpha(theme.palette.primary.main, 0.11)
            }
          }
        },
        cell: {
          color: theme.palette.text.primary,
          fontSize: '0.875rem',
          padding: '8px 12px',
          borderBottom: 0,
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center'
        },
        footerContainer: {
          backgroundColor: '#f8fafc',
          borderTop: `1px solid ${theme.palette.divider}`
        }
      }
    }
  };
}
